export const urlMap = {
  community: "community",
  main: 1,
  "cinematic-universes": 6,
  "story-arcs": 2,
  characters: 3,
  groups: 4,
  creators: 5,
};

export const titleMap = {
  main: "Main Reading Orders",
  "cinematic-universes": "Cinematic Universes",
  "story-arcs": "Story Arcs & Events",
  characters: "Characters",
  groups: "Groups",
  creators: "Creators runs",
};

export const browseTitleMap = {
  community: "Community",
  main: "Main Reading Orders",
  "cinematic-universes": "Cinematic Universes",
  "story-arcs": "Story Arcs & Events",
  characters: "Characters",
  groups: "Groups",
  creators: "Creators' Runs",
};

export const urlMapIndex = {
  1: "main",
  6: "cinematic-universes",
  2: "story-arcs",
  3: "characters",
  4: "groups",
  5: "creators",
};

export const readingtitleMapIndex = {
  0: "My Orders",
  1: "Main Reading Orders",
  6: "Cinematic Universes",
  2: "Story Arcs & Events",
  3: "Characters",
  4: "Groups",
  5: "Creators runs",
};

export const titleMapIndex = {
  1: "Main Reading Orders",
  6: "Cinematic Universes",
  2: "Story Arcs & Events",
  3: "Characters",
  4: "Groups",
  5: "Creators runs",
};

export const titleSingleMapIndex = {
  1: "Main Reading Order",
  6: "Cinematic Universe",
  2: "Story Arc/Event",
  3: "Character",
  4: "Group",
  5: "Creator run",
};

export const franchiseMapIndex = {
  1: "Marvel",
  2: "DC",
  3: "Star Wars",
  4: "Image comics",
};

export const comicImportSources = {
  1: {
    sourceKey: "marvel",
    sourceLabel: "Marvel.com",
    urlFormat:
      "E.g: https://www.marvel.com/comics/issue/99743/spider-man_2022_1",
  },
  2: {
    sourceKey: "dc_fandom",
    sourceLabel: "DC Fandom",
    urlFormat: "E.g: https://dc.fandom.com/wiki/Batman_Vol_3_4",
  },
  3: {
    sourceKey: "dcui",
    sourceLabel: "DC UI (Series)",
    urlFormat:
      "E.g: https://www.dcuniverseinfinite.com/comics/series/the-question-1986-2010/3d7786d3-038e-4ec9-9229-645acd01c149",
  },
};

export const publicComicImportSources = {
  1: {
    sourceKey: "marvel",
    sourceLabel: "Marvel.com",
    urlFormat:
      "E.g: https://www.marvel.com/comics/issue/99743/spider-man_2022_1",
  },
  2: {
    sourceKey: "marvel_fandom",
    sourceLabel: "Marvel Fandom (experimental)",
    urlFormat: "E.g: https://marvel.fandom.com/wiki/Fantastic_Four_Vol_1_5",
  },
  3: {
    sourceKey: "dc_fandom",
    sourceLabel: "DC Fandom (experimental)",
    urlFormat: "E.g: https://dc.fandom.com/wiki/Batman_Vol_3_4",
  },
  4: {
    sourceKey: "image_fandom",
    sourceLabel: "Image Comics Fandom (experimental)",
    urlFormat: "E.g: https://imagecomics.fandom.com/wiki/Spawn_Vol_1_9",
  },
};

export const readingOrderStatus = {
  read: "Read",
  skipped: "Skipped",
  readLater: "Read later",
  unread: "Unread",
  all: "All",
};

export const stripeProducts = {
  1: {
    title: "Monthly",
    price: "$2.99 / month",
    amount: 2.99,
    currency: "USD",
    priceId: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID,
  },
  2: {
    title: "Yearly",
    price: "$29.99 / year",
    amount: 29.99,
    currency: "USD",
    priceId: process.env.REACT_APP_STRIPE_YEARLY_PRICE_ID,
  },
};
